import { setOpenDrawer } from '@vs/rtk/slices/genericGlobal';
import { SpaMenuByPathsConfig } from '@vs/shared-context/spa-path-config-provider';
import { memo } from 'react';

import { useAppDispatch, useAppSelector } from '../../redux/hooks';

function Menu() {
  const dispatch = useAppDispatch();
  const openDrawer = useAppSelector(s => s.general.openDrawer);

  function closeDrawer() {
    dispatch(setOpenDrawer(false));
  }

  return (
    <SpaMenuByPathsConfig
      expand={openDrawer}
      onClick={closeDrawer}
      onEsc={closeDrawer}
    />
  );
}

export default memo(Menu);
